import { render } from "./TheBlobDialog.vue?vue&type=template&id=13ab7318"
import script from "./TheBlobDialog.vue?vue&type=script&lang=js"
export * from "./TheBlobDialog.vue?vue&type=script&lang=js"

import "./TheBlobDialog.vue?vue&type=style&index=0&id=13ab7318&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__